import script from "./VisualizerHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizerHeader.vue?vue&type=script&setup=true&lang=js"

import "./VisualizerHeader.vue?vue&type=style&index=0&id=65ac8bfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ac8bfe"]])

export default __exports__